import { render, staticRenderFns } from "./manage-environmental-top.vue?vue&type=template&id=bf10ab32&scoped=true&"
import script from "./manage-environmental-top.vue?vue&type=script&lang=js&"
export * from "./manage-environmental-top.vue?vue&type=script&lang=js&"
import style0 from "./manage-environmental-top.vue?vue&type=style&index=0&id=bf10ab32&prod&lang=scss&scoped=true&"
import style1 from "./manage-environmental-top.vue?vue&type=style&index=1&id=bf10ab32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10ab32",
  null
  
)

export default component.exports